import React, { Fragment } from "react";
import { Link } from 'react-router-dom';


const Description = ()=> {

  return (
    <Fragment>
      <div className="description-overlay">
        <h5> Claim a bonus from our Telegram channel </h5>
        <p> We do giveaways very often on our Telegram channel. Be fast enough and you can catch rewards of up to <strong>2.000</strong> points each. </p>
      </div>
      <Link className="btn action btn-primary" target="_blank" to={{pathname: "https://t.me/earndorado"}}>Visit Our Telegram</Link>
    </Fragment>
  );

};

export default Description;
